$(_ => {

    var escapeHTML = function escapeHtml(unsafe) {
        return ('' + unsafe)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&apos;");
  };

    $.backstretch(_imagenes.map(o => o.rad_url), { fade: 1000, duration: 8000 });

    $('#lb_login_version_publicacion').tooltip();
    
    var slu_html = `<option disabled value="-1"><span>.: Mas de una unidad médica :.</span></option>
                            <option selected value="-2"><span>.: Sin Datos :.</span></option>
    ${ums.map(org => `<optgroup label="${escapeHtml(org.org)}">    
    ${org.ums.map(u => `<option disabled value="${u.id}">${escapeHtml(u.uni)}</option>`).join("\n")} 
    </optgroup>`).join("\n")}`;

  
    $('#sl_unidadesmedicas').html(slu_html);
    $('#dv_ums').toggle(true);
    $("#sl_unidadesmedicas").chosen({ search_fuzzy: true, display_disabled_options: false });
    $('#dv_ums').toggle(false);
    //$('.badgeUnidadesMedicas').html(ums.length-1);

    $("#sl_unidadesmedicas").data('chosen').container.on('keypress', e => {
        if (e.which == 13) {
            $('#bt_entrar').trigger('click');
            return false;
        }
    });

    $.fn.toggleSelect = function toggleSelect(val = true) {
        if (!val) {
            $(this).attr("disabled", null);
        } else {
            $(this).attr("disabled", "disabled");
        }
        $(this).prop("disabled", !val);
        if (val) {
            $($(this).get(0)).prop('selected', true);
        }
    };

    var optnodata = $('#sl_unidadesmedicas option[value="-2"]'),
        optmas = $('#sl_unidadesmedicas option[value="-1"]');

    function preparaSlu(cuales) {
        
        $('#sl_unidadesmedicas option').toggleSelect(0);
        if (cuales) {
            cuales.toggleSelect(1);
            if (cuales.length > 1) {
                optmas.toggleSelect(1);
            }
        }
        if (!cuales || cuales.length === 0) {
            optnodata.toggleSelect(1);
        }
        $('#sl_unidadesmedicas').trigger('chosen:updated');
        $('#dv_ums').toggle(!!(cuales && cuales.length > 1));
    }

    $('#tx_usuario').on("change", function () {
        $('#tx_usuario').val($.trim($('#tx_usuario').val()));
        $("#dv_ums").hide()
        preparaSlu(0);

        //Se conierte a mayuscula
        if ($('#tx_usuario').val().indexOf('@') <= 0) {
            $('#tx_usuario').val($('#tx_usuario').val().toUpperCase());
        } else {
            $('#tx_usuario').val($('#tx_usuario').val().toLowerCase());
        }

        if ($('#tx_usuario').val() == '') {
            swal('Validación', 'Ingrese un nombre de usuario!!!', 'info');
        }
        else {
          
            var mdu = md5($(this).val().trim() + md5($(this).val().trim()));
            var unids;                       

            //Aqui se muestran las unidades medicas
            if ((unids = umus.filter(u => u.u === mdu || u.e === mdu)).length) {
                unids = unids[0];
                let aplican = $('#sl_unidadesmedicas option').filter(function () {                    
                    return unids.ums.indexOf(parseInt($(this).val(), 10)) >= 0;
                });
                preparaSlu(aplican);
                $('.badgeUnidadesMedicas').html(aplican.length);
            }
            //Se oculta hasta que la contraseña este correcta
            $("#dv_ums").hide();
            $("#bt_entrar").hide();
            window.setTimeout(chosenfit("sl_unidadesmedicas"),300)
            
        }
    });

    if ($('#tx_usuario').val().trim() !== "") {
        $('#tx_usuario').trigger("change");
    }

    $('#tx_usuario').keypress(function (e) {
        if (e.which == 13) {
            $('#tx_contrasenia').focus().select();
            return false;
        }
    });

    // 20/10/2022
    // Refactoring para que no se lanze el evento 'focusout' (login) dos veces
    $('#tx_contrasenia')
        .off('keydown')
        .on('keydown', function (e) {
            // Se tiene que comprobar si hay varias unidades medicas para seleccionar

            // 20/10/2022
            // Se implementa corrección para que no se lanze el evento 'focusout' dos veces
            // cuando se presiona la tecla 'enter' o 'tab'
            if (e.which == 13 || e.which == 9) {
                $(this).unbind('focusout');

                autenticarUsuario(true);
            }
        });

    $('#tx_contrasenia').off('focusout').on('focusout', autenticarUsuario.bind(this, false));

    //funcion mas generica para obtener el sistema operativo
    function fn_obtenerAppVersion() {
        if (navigator.userAgent.indexOf("Windows NT 10.0") != -1) {
            return "Windows 10-11";
        } else if (navigator.userAgent.indexOf("Windows NT 6.3") != -1) {
            return "Windows 8.1";
        } else if (navigator.userAgent.indexOf("Windows NT 6.2") != -1) {
            return "Windows 8";
        } else if (navigator.userAgent.indexOf("Windows NT 6.1") != -1) {
            return "Windows 7";
        } else if (navigator.userAgent.indexOf("Windows NT 6.0") != -1) {
            return "Windows Vista";
        } else if (navigator.userAgent.indexOf("Windows NT 5.2") != -1) {
            return "Windows Server 2003";
        } else if (navigator.userAgent.indexOf("Windows NT 5.1") != -1) {
            return "Windows XP";
        } else if (navigator.userAgent.indexOf("Windows NT 5.01") != -1) {
            return "Windows 2000, Service Pack 1 (SP1)";
        } else if (navigator.userAgent.indexOf("Windows NT 5.0") != -1) {
            return "Windows 2000";
        } else if (navigator.userAgent.indexOf("Windows NT 4.0") != -1) {
            return "Windows NT 4.0";
        } else if (navigator.userAgent.indexOf("Windows 98; Win 9x 4.90") != -1) {
            return "Windows Millennium Edition (Windows Me)";
        } else if (navigator.userAgent.indexOf("Windows 98") != -1) {
            return "Windows 98";
        } else if (navigator.userAgent.indexOf("Windows 95") != -1) {
            return "Windows 95";
        } else if (navigator.userAgent.indexOf("Windows CE") != -1) {
            return "Windows CE";
        } else if (navigator.userAgent.indexOf("Mac") != -1) {
            return "MacOS";
        } else if (navigator.userAgent.indexOf("X11") != -1) {
            return "UNIX";
        } else if (navigator.userAgent.indexOf("Linux") != -1) {
            return "Linux";
        }           
    }

    // funcion para obtener mas especificamente la version del sistema operativo en windows (no funciona en firefox)
    async function fn_obtenerSO() {
        if (navigator.userAgentData != undefined) {
            return navigator.userAgentData.getHighEntropyValues(["platformVersion"]).then(ua => {
                if (navigator.userAgentData.platform === "Windows") {
                    const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);

                    if (majorPlatformVersion >= 13) {
                        return "Windows 11";
                    }
                    else if (majorPlatformVersion > 0) {
                        return "Windows 10";
                    } else {
                        return fn_obtenerAppVersion();
                    }
                } else {
                    return fn_obtenerAppVersion();
                }
            });
        } else {
            return fn_obtenerAppVersion();
        }
    }

    // 20/10/2022
    // Nueva función como parte del refactoring para que no se lanze el evento 'focusout' dos veces
    async function autenticarUsuario(pvolverAEnlazar = false) {
        let usr = $('#tx_usuario').val().trim(), pss = $('#tx_contrasenia').val().trim();

        if (usr !== '' && pss !== '') {
            $.blockUI({
                message: '<img src="' + _raiz + 'images/cargando.gif" alt="" style="height: 50px;"><br><h3>&nbsp;Validando...</h3>',
                css: {
                    padding: 0,
                    margin: 0,
                    width: '30%',
                    top: '40%',
                    left: '35%',
                    textAlign: 'center',
                    color: '#FFF',
                    border: 'none',
                    backgroundColor: 'rgba(221, 221, 221, 0)',
                    cursor: 'wait'
                }
            });

            const so = await fn_obtenerSO();

            let solicitud = await $.ajax({
                type: 'POST',
                dataType: 'JSON',
                url: _raiz + 'Asincronos/Seguridad/_validaUsuarioPass.ashx',
                data: {
                    usu: usr,
                    pass: pss,
                    so: so
                }
            });

            $.unblockUI();

            if (solicitud.err) {
                swal('ALERTA', solicitud.mensaje, 'error');

                $('#dv_ums').hide();

                $('#bt_entrar').hide();
            } else {
                if (solicitud.data[0].existe == '0') {
                    swal('ALERTA', 'Usuario o contraseña incorrectos', 'info');

                    $('#dv_ums').hide();

                    $('#bt_entrar').hide();
                } else {
                    $('#dv_ums').show();

                    $('#bt_entrar').show();

                    $('#sl_unidadesmedicas').trigger('chosen:activate');

                    // Si solo tiene una opcion, se inicia en automatico
                    if (parseInt($('.badgeUnidadesMedicas').html()) == 1) {
                        $('#bt_entrar').trigger('click');
                    }
                }
            }
        }

        if (pvolverAEnlazar) {
            $('#tx_contrasenia').off('focusout').on('focusout', autenticarUsuario.bind(this, false));
        }
    }    

    $('#bt_entrar').on('click', async _ => {
        if (($('#sl_unidadesmedicas option').length <= 0) || ($('#sl_unidadesmedicas :selected').val() == '-1')) {
            swal({ title: 'Validación:', text: 'No tiene unidad médica asignada', type: "warning" });
        } else {                        
            $.blockUI({
                message: '<img src="' + _raiz + 'images/cargando.gif" alt="" style="height: 50px;"><br><h3>Iniciando sesión</h3>',
                css: {
                    padding: 0,
                    margin: 0,
                    width: '30%',
                    top: '40%',
                    left: '35%',
                    textAlign: 'center',
                    color: '#FFF',
                    border: 'none',
                    backgroundColor: 'rgba(221, 221, 221, 0)',
                    cursor: 'wait'
                }
            });
                        
            try {
                let r = await Promise.resolve($.ajax({
                    type: 'POST',
                    dataType: 'JSON',
                    url: 'asincronos/seguridad/_login.ashx',
                    data: {
                        usuario: $.trim($('#tx_usuario').val()),
                        contrasenia: $.trim($('#tx_contrasenia').val()),
                        unidadMedicaID: $('#sl_unidadesmedicas :selected').val(),
                        unidadMedica: $('#sl_unidadesmedicas :selected').text()
                    }
                }).then(r => {                    
                    if (r.err) {
                        swal({ title: 'Validación:', text: r.msg, type: r.tipoErr, html: true });
                        $.unblockUI();
                        //swal('Validación', r.msg, r.tipoErr);
                    } else {
                        $.ajax({
                            dataType: 'JSON',
                            data: {
                                tema: ($('body').hasClass('oscuro') ? 'oscuro' : ''),
                                accion: 'to'
                            },
                            url: _raiz + 'asincronos/Seguridad/_sesiones.ashx'
                        });
                        localStorage.setItem("sl_medico", 0); //inicializamos en 0 la bandera del medico seleccionado del listado de pacientes                                               
                        window.location.href = 'index.aspx'
                    }
                }, (x, t, e) => swal('Error:', e)
                    ))
                    .catch(e => console.log(e));
                return false;
            }
            catch (ex) {
                console.log(ex);
            }
        }
    });     
    
    //Funciones para la recuperacion de la contraseña y el mandar el correo -------
    $("#btn_fpass").on('click', function () {
        var usuario = $("#tx_usuario").val();//Ya viene en mayusculas
        if (usuario !== '' && usuario.length > 4) {
            //Si trae datos
            $("#tx_usuarioPass").val("" + usuario);
            //Se consulta el correo
            Promise.resolve($.ajax({
                type: 'POST',
                dataType: 'JSON',
                url: _raiz + 'asincronos/Seguridad/_login.ashx',
                data: {
                    accion: 'obtener_correo',
                    pusuario: usuario
                }
            }).then(r => {
                if (r.err) {
                    console.log("Error al obtener e correo")
                    swal('ALERTA', 'No se pudo obtener el correo', 'info');
                    limpiarBusquedaCorreo();
                } else {
                    if (r.conteo > 0) {
                        //Se guarda el id del usuario
                        $("#tx_usuarioPass").data("idusuario", r.data[0].loginid);
                        $("#tx_usuarioPass").data("usuarioname", r.data[0].nombre + " " + r.data[0].apaterno + " " + r.data[0].amaterno);
                        //Si viene vacio el correo, se activa el poder guardar el correo
                        r.data[0].correo == "" ? $("#guarda_correo_Val").val("true") : $("#guarda_correo_Val").val("false");
                        //Se llena el campo
                        $("#tx_mailPass").val(r.data[0].correo);
                        $("#usuario_actual").val(usuario);//Este se usa para saber si estamos sobre el mismo usuario o cambio
                        registroToken();//Se registra si hay usuario encontrado
                        //window.setTimeout("$('#tx_usuarioPass').focus().select();", 500);//Se manda el focus al usuario
                    }
                    else {
                        //Se limpian los campos ya que no se encontraron datos del usuario
                        limpiarBusquedaCorreo();
                    }
                }
            }
            )).catch(e => console.log(e));
        }
        else {
            //No trae datos
            limpiarBusquedaCorreo();
        }

        $('#div_alertCorreo').css("display", "none");//Cuando faltan datos de llenar
        $("#md_forgotPass").modal("show");
    });

    $("#tx_usuarioPass").on('focusout', function () {
        $.blockUI({
            message: '<img src="' + _raiz + 'images/cargando.gif" alt="" style="height: 50px;"><br><h3>Buscando usuario</h3>',
            css: {
                padding: 0,
                margin: 0,
                width: '30%',
                top: '40%',
                left: '35%',
                textAlign: 'center',
                color: '#FFF',
                border: 'none',
                backgroundColor: 'rgba(221, 221, 221, 0)',
                cursor: 'wait'
            }
        });
        var usuario = $("#tx_usuarioPass").val();
        var actual = $("#usuario_actual").val();
        var oportunidad = $("#val_oportunidades").val();
        usuario = usuario.toUpperCase();
        if (usuario !== '') {
            //Se consulta el correo
            if (oportunidad == '') {
                if (usuario != actual) {
                    Promise.resolve($.ajax({
                        type: 'POST',
                        dataType: 'JSON',
                        url: _raiz + 'asincronos/Seguridad/_login.ashx',
                        data: {
                            accion: 'obtener_correo',
                            pusuario: usuario
                        }
                    }).then(r => {
                        if (r.err) {
                            console.log("Error al obtener e correo")
                            swal('ALERTA', 'No se pudo obtener el correo', 'info');
                            limpiarBusquedaCorreo();
                        } else {
                            if (r.conteo > 0) {
                                //si el correo viene vacio, se activa el poder guardar
                                r.data[0].correo == "" ? $("#guarda_correo_Val").val("true") : $("#guarda_correo_Val").val("false");
                                //Se llena el campo
                                $("#tx_usuarioPass").val(usuario);
                                $("#tx_usuarioPass").data("idusuario", r.data[0].loginid);
                                $("#tx_usuarioPass").data("usuarioname", r.data[0].nombre + " " + r.data[0].apaterno + " " + r.data[0].amaterno);
                                $("#tx_mailPass").val(r.data[0].correo);
                                $('#tx_mailPass').focus().select();
                                $("#usuario_actual").val(usuario);//Este se usa para saber si estamos sobre el mismo usuario o cambio
                                registroToken();
                            }
                            else {
                                //Se limpian los campos ya que no se encontraron datos del usuario
                                swal({
                                    title: 'ALERTA',
                                    text: "No se encontro el usuario",
                                    type: 'warning',
                                    showConfirmButton: false,
                                    confirmButtonText: 'Yes, delete it!'
                                })
                                //Se limpian los campos
                                limpiarBusquedaCorreo();
                                //window.setTimeout("$('#tx_usuarioPass').focus().select();", 2500);//Se manda el focus al usuario
                            }
                        }
                        $.unblockUI();
                    }
                    ))
                }
                else {
                    $.unblockUI();
                }
            }
            else {
                swal({
                    title: 'ALERTA',
                    text: "Supero el numero de intentos, vuelva a intentarlo mas tarde",
                    type: 'warning',
                    showConfirmButton: false,
                    confirmButtonText: 'Yes, delete it!'
                })
                limpiarBusquedaCorreo();
                $.unblockUI();
            }
        }
        else {
            limpiarBusquedaCorreo();
            $.unblockUI();
        }
    });

    $("#tx_mailPass").on("focusout", function () {
        var m1 = $("#tx_usuarioPass").val();
        var m2 = $("#tx_mailPass").val();
        if (m2 !== '') {
            if (!m2.includes('@') || !m2.includes('.com') && m1 != '') {
                $('#div_alertCorreo').css("display", "block")
            }
            else {
                $('#div_alertCorreo').css("display", "none")
            }
        }
    })

    $('#tx_usuarioPass').keypress(function (e) {
        if (e.which == 13) {
            $('#tx_mailPass').focus().select();
            return false;
        }
    });

    $('#tx_mailPass').keypress(function (e) {
        if (e.which == 13) {
            $('#btn_mandarcorreopass').click();
            return false;
        }
    });

    $("#btn_mandarcorreopass").on('click', function () {
        $.blockUI({
            message: '<img src="' + _raiz + 'images/cargando.gif" alt="" style="height: 50px;"><br><h3>Mandando correo</h3>',
            css: {
                padding: 0,
                margin: 0,
                width: '30%',
                top: '40%',
                left: '35%',
                textAlign: 'center',
                color: '#FFF',
                border: 'none',
                backgroundColor: 'rgba(221, 221, 221, 0)',
                cursor: 'wait',
                zindex: 99999,
            }
        });
        var m1 = $("#tx_usuarioPass").val(), m2 = "" + $("#tx_mailPass").val(), m3 = $("#div_alertCorreo");
        if (m1 != "" && m2 != "" & m3.is(':hidden')) {
            //Se verifica si se va a guardar el correo
            var seguarda = $("#guarda_correo_Val").val()
            var correo = $("#tx_mailPass").val();
            var usu = $("#tx_usuarioPass").data("idusuario");
            var usu_name = $("#tx_usuarioPass").data("usuarioname");
            var tk = $("#val_token").val()
            var url = window.location.href + "recuperar_password.aspx?T=" + tk + "&L=" + usu;

            if (seguarda == "true") {
                var usuarioid = $("#tx_usuarioPass").data("idusuario");

                Promise.resolve($.ajax({
                    type: 'POST',
                    dataType: 'JSON',
                    url: _raiz + 'asincronos/Seguridad/_login.ashx',
                    data: {
                        accion: 'guardar_correo_usuario',
                        pusuarioid: usuarioid,
                        pcorreo: m2
                    }
                }).then(r => {
                    if (r.err) {
                        console.log("Error al guardar el correo")
                        swal('ALERTA', 'No se pudo guardar el correo', 'info');
                    } else {
                        console.log(r)
                    }
                }
                )).catch(e => console.log(e));
            }

            //Se manda el correo

            $.fn_leerPlantilla({
                id: "recupera_contraseña",
                campos: [
                    {
                        key: "{user_name}",
                        value: usu_name
                    },
                    {
                        key: "{url}",
                        value: url
                    }
                ],
                onSuccess: function (datos) {
                    var enviado = false;
                    setTimeout(function () {
                        if (!enviado) {
                            onError(e);
                            enviado = true;
                        }
                    }, 10000);
                    $.unblockUI();
                    $.fn_enviaCorreo({
                        origen: "esalud@chihuahua.gob.mx",
                        destino: correo,
                        asunto: "Recuperacion de contraseña",
                        contenido: datos,
                        onSuccess: function (v) {
                            if (!enviado) {
                                enviado = true;
                                //Se cierra y se notifica 
                                $("#md_forgotPass").modal("hide");
                                $.unblockUI();
                                console.log("correo enviado");
                                swal('Enviado', 'Correo enviado con exito', 'info');
                            }
                        },
                        onError: function (e) {
                            if (!enviado) {
                                $.unblockUI();
                                enviado = true;
                                console.log(e);
                                registrarError({ usuarioid: usuarioid, correo: correo, datos: contenido, asunto: "Alta de usuario" })
                                onError(e);
                            }
                        }
                    });
                },
                onError: function () {
                    $.unblockUI();
                    console.log("error");
                    onError(e);
                }
            });
        }
        else {
            //swal('Advertencia', 'Faltan campos por llenar', 'info');
            $('#div_alertCorreo').css("display", "block")
            $('#tx_usuarioPass').focus().select();
            $.unblockUI();
        }
    });

    $("#md_forgotPass").on('hidden.bs.modal', function () {
        $("#val_oportunidades").val("");
    });

    function registroToken() {
        //Se registran los token
        console.log("Entro al focus");
        var usuariotid;
        var idlogin = $("#tx_usuarioPass").data("idusuario");
        idlogin == "" ? usuariotid = -1 : usuariotid = idlogin;
        var usuario = $("#tx_usuarioPass").val();
        var correo = $("#tx_mailPass").val();
        Promise.resolve($.ajax({
            type: 'POST',
            dataType: 'JSON',
            url: _raiz + 'asincronos/Seguridad/_login.ashx',
            data: {
                accion: 'intentos_consulta_correo',
                pusuarioid: usuario,
                p_loginid: usuariotid,
                p_correo: correo,
            }
        }).then(r => {
            if (r.err) {
                swal({
                    title: 'ALERTA',
                    text: "Supero el numero de intentos al ingresar el usuario, vuelva a intentarlo en 20min",
                    type: 'warning',
                    showConfirmButton: false,
                    confirmButtonText: 'Yes, delete it!'
                })
                $("#val_oportunidades").val("Falso");
                limpiarBusquedaCorreo();
                //window.setTimeout("$('#md_forgotPass').modal('hide')", 3500);//Se manda el focus al usuario
                //intentos_consulta_correo
            } else {
                $("#val_token").val(r.data)
                $("#val_oportunidades").val("");
                console.log("Token "+r.data);
            }
        }
        )).catch(e => console.log(e));
    }

    function limpiarBusquedaCorreo() {
        //Se limpian los campos
        $("#tx_usuarioPass").val("");
        $("#tx_mailPass").val("");
        $("#tx_usuarioPass").data("idusuario", "-1");
        $("#tx_usuarioPass").data("usuarioname", "-1");
        $("#guarda_correo_Val").val("false");
        $("#val_token").val("-1")
        $("#usuario_actual").val("");
        window.setTimeout("swal.close()", 2000);//se cierran los swal
        //window.setTimeout("$('#tx_usuarioPass').focus().select();", 2500);//Se manda el focus al usuario
    }
    //Recuperacion de la contraseña--------------------------------------------

    $('#form1').submit(e => {
        e.preventDefault();
        e.stopPropagation();
    });

    $('#tx_usuario').focus().select();
});

$(function () {
    let le, url = "https://fonts.googleapis.com/css?family=Open+Sans:400,300,600,700&subset=all";
    le = document.createElement("link");
    le.setAttribute("rel", "stylesheet");
    le.setAttribute("type", "text/css");
    le.setAttribute("href", url);
    document.head.appendChild(le);
});